let config = {
    indexData: 'refineSearchMultimakemodelIndex',
    addDataPath: 'data-refine-search-multimakemodel-add-more',
    removeDataPath: 'data-refine-search-multimakemodel-remove',
    hiddenClass: 'hidden',
    addClass: '[data-refine-search-multimakemodel].hidden'
};

export default class RefineSearchMultiMakeModel {
    constructor(element, options) {
        config = $.extend(config, options);
        this.$element = $(element);
        this.index = this.$element.data(config.indexData);
        this.$removeControl = $(`[${config.removeDataPath}=${this.index}]`);
        this.$addControl = $(`[${config.addDataPath}]`);
    }

    remove() {
        this.$element.addClass(config.hiddenClass);
        this.clearInputs();
        this.updateControl();
        this.updateCollapse();
        this.updateInputs(this.$element);
        return false;
    }

    add() {
        let $element = $(config.addClass).first();
        $element.removeClass(config.hiddenClass);
        this.updateControl();
        this.updateInputs($element);
        return false;
    }

    clearInputs() {
        $(`#makes-menu-${this.index}`).find('.js-item').first().trigger('tap');
        this.$element.find('input').each((index, el) => {
            $(el).prop('value', '').trigger('change');
        });
    }

    updateControl() {
        if (!$(config.addClass).length) {
            this.$addControl.addClass(config.hiddenClass);
        } else {
            this.$addControl.removeClass(config.hiddenClass);
        }
    }

    updateInputs($element) {
        $element.find('input').prop('disabled', (i, v) => {
            return !v;
        });
    }

    updateCollapse() {
        if (this.defaultIsOpenState !== this.$element.hasClass('is--open')) {
            this.$element.find('[data-collapsible-control]').first().click();
        }
    }

    setListeners() {
        this.$removeControl
            .off('click.remove', '', $.proxy(this, 'remove'))
            .on('click.remove', $.proxy(this, 'remove'));

        this.$addControl
            .off('click.add', '', $.proxy(this, 'add'))
            .on('click.add', $.proxy(this, 'add'));
    }

    init() {
        this.setListeners();
        this.defaultIsOpenState = this.$element.hasClass('is--open');
    }
}